/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { PortableText } from '@portabletext/react';
import { useSanityNewsByUrlId } from '../../../../../../../../../../../../sanity';
import { SanityInternalLink, SanityLink } from '../../../../../../../../../../../oblisPortableText/components';
import { Disclaimer, disclaimerCss } from '../../../../../../../../../../../disclaimer';

const components = {
  marks: {
    link: (props) => (
      <SanityLink
        value={props.value}
      >
        {props.children}
      </SanityLink>
    ),
    internalLink: (props) => (
      <SanityInternalLink
        value={props.value}
      >
        {props.children}
      </SanityInternalLink>
    ),
  },
};

export const ArticleDisclaimer = () => {
  const {
    data,
  } = useSanityNewsByUrlId();
  return data?.disclaimer == null || data?.disclaimer?.length === 0
    ? <Disclaimer />
    : (
      <div
        css={disclaimerCss}
      >
        <PortableText value={data.disclaimer} components={components} />
      </div>
    );
};
